import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { query } from 'umg-ember-backend/data/builders/umg-rest';

const RECORD_TYPE = 'category';

export default class AdminCategoriesIndexRoute extends Route {
  // Services
  @service breadcrumb;
  @service filter;
  @service store;

  // Defaults
  queryParams = {
    type: {
      refreshModel: true,
      cmsState: true,
    },
  };

  // Hooks
  async model(params) {
    let queryObject = this.filter.getQueryObject(RECORD_TYPE, params);

    const { content } = await this.store.request(
      query(RECORD_TYPE, queryObject),
    );

    return content;
  }

  afterModel() {
    this.breadcrumb.registerExplorerRoute(RECORD_TYPE);
  }
}
